export const updateCard = /* GraphQL */ `
    mutation UpdateCard(
        $input: UpdateCardInput!
        $condition: ModelCardConditionInput
    ) {
        updateCard(input: $input, condition: $condition) {
            id
            group
            stripeSetupIntent
            stripeCustomerId
            stripePaymentMethodId
            active
            createdAt
            chargeError
            updatedAt
        }
    }
`;

export const deleteCard = /* GraphQL */ `
    mutation DeleteCard(
        $input: DeleteCardInput!
        $condition: ModelCardConditionInput
    ) {
        deleteCard(input: $input, condition: $condition) {
            id
            group
            stripeSetupIntent
            stripeCustomerId
            stripePaymentMethodId
            active
            createdAt
            chargeError
            updatedAt
        }
    }
`;